import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'getSanitizedHtml',
    standalone: false
})
export class GetSanitizedHtmlPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {}
    transform(html: string): SafeHtml {
        return this.domSanitizer.bypassSecurityTrustHtml(html);
    }
}

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, limit: number): string {
        if (!value) {
            return '';
        }
        return value.length < limit ? value : value.slice(0, limit) + '...';
    }
}

@Pipe({
    name: 'getSafeUrl',
    standalone: false
})
export class GetSafeUrlPipe implements PipeTransform {
    constructor(private readonly domSanitizer: DomSanitizer) {}

    transform(url: string): SafeResourceUrl {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
